<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------

========================================================================================== -->


<template>
  <div class="layout--full-page">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  components: {
    
  },
  data () {
    return {
      
    }
    
  },
  watch: {
    "$store.state.loading": function(val) {
      if(val) {
        this.$vs.loading({
              type:'material'
          })
      } else {
        this.$vs.loading.close()
      } 
    },
    
  },
  computed: {
    
  },
  methods: {
    
  },
  created () {
    
  }
}
</script>
